<template>
  <div>
    <paper-trades-summary
      v-if="tabValue !== 'Inactive'"
      :tabValue="tabValue"
    ></paper-trades-summary>
  </div>
</template>
<script>
export default {
  name: "PaperTrades",
  props: {
    tabValue: {
      type: String,
    },
  },
  components: {
    PaperTradesSummary: () => import("./PaperTradesSummary/PaperTradesSummary.vue"),
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {},
  mounted() {},
};
</script>
